import { render, staticRenderFns } from "./BtnNext.vue?vue&type=template&id=2bce58e3&"
import script from "./BtnNext.vue?vue&type=script&lang=js&"
export * from "./BtnNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bce58e3')) {
      api.createRecord('2bce58e3', component.options)
    } else {
      api.reload('2bce58e3', component.options)
    }
    module.hot.accept("./BtnNext.vue?vue&type=template&id=2bce58e3&", function () {
      api.rerender('2bce58e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/form/btnNext/BtnNext.vue"
export default component.exports